export const PAIDIT_SERVER = process.env.NODE_ENV === 'production' ? '/' : 'http://localhost:10009/';

export const MOBILE_SERVER = process.env.NODE_ENV === 'production' ? 'https://pi-mobile-service.production.paidit.io/' : 'http://localhost:10011/';

export const PAIDIT_API = `${PAIDIT_SERVER}api/`;

export const ORDERS_UPDATE_INTERVAL = 12000;

export const GOOGLE_API_KEY = (window.__PANEL_CONFIG__ || {}).googleApiKey || process.env.REACT_APP_GOOGLE_API_KEY;

export const ENCRYPTION_CIPHER = process.env.REACT_APP_ENCRYPTION_CIPHER;

export const S3_BASE_URL = 'https://s3.eu-west-1.amazonaws.com';

export const S3_COMMON_ASSETS = '/assets.paidit.common-bucket';